module.exports = __webpack_public_path__ + "media/images/fr/upload-confirmation-9ab9ae88dac862867e71e48092741935.png";